'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClientHandOffAction = undefined;

var _constants = require('./constants');

/**
 * Client HandOff Action creator
 * @return {Object} The action to be dispatched
 */
exports.default = function () {
  return {
    type: _constants.CLIENT_HANDOFF
  };
};

/**
 * Tests wether a given action is of CLIENT_HANDOFF type
 * @param {Object} action The action being validated
 * @return {Boolean} true if type is CLIENT_HANDOFF
 */


var isClientHandOffAction = exports.isClientHandOffAction = function isClientHandOffAction(action) {
  return action && action.type === _constants.CLIENT_HANDOFF;
};
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-client-handoff-action/dist/main/actions.js
// module id = 509
// module chunks = 0